import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { getRegFormType } from "Utils/utils";
import { Track } from "..";
import { getDateTimeStringInEst, getTimeSpentInSeconds } from "../utils";

let regFormOpenedTimestamp: Date | undefined;

export const RegistrationEvents = {
  CLIENT_REG_FORM_OPENED: "Client_Reg_Form_Opened",
  CLIENT_REG_FORM_CLOSED: "Client_Reg_Form_Closed",
};

export const useRegFormOpenCloseTracker = (isCif: boolean) => {
  const dispatch = useDispatch();

  const trackRegFormOpened = useCallback(() => {
    const now = new Date();
    regFormOpenedTimestamp = now;
    const regFormOpenedDateTime = getDateTimeStringInEst(now);

    dispatch(
      Track({
        event: RegistrationEvents.CLIENT_REG_FORM_OPENED,
        params: {
          form_type: getRegFormType(isCif),
          method: "CTA button click",
          client_reg_form_opened_timestamp: regFormOpenedDateTime,
        },
        vendor: "gainsight",
      })
    );
  }, [isCif, dispatch]);

  const trackRegFormClosed = useCallback(
    (method: "Exited" | "Complete") => {
      const now = new Date();
      const regFormClosedDateTime = getDateTimeStringInEst(now);

      dispatch(
        Track({
          event: RegistrationEvents.CLIENT_REG_FORM_CLOSED,
          params: {
            form_type: getRegFormType(isCif),
            method,
            client_reg_form_closed_timestamp: regFormClosedDateTime,
            client_reg_form_closed_time_spent_seconds: getTimeSpentInSeconds(
              regFormOpenedTimestamp,
              now
            ),
          },
          vendor: "gainsight",
        })
      );
    },
    [isCif, dispatch]
  );

  return { trackRegFormOpened, trackRegFormClosed };
};
